var path = '/app/components/login.component.html';
var html = "<iframe id=\"autoalertiframe\" class=\"iframe-autoalert\" ng-src=\"{{$ctrl.src}}\" frameborder=\"0\" scrolling=\"yes\" height=\"100%\" width=\"100%\"></iframe>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;